let environment = 'dev';
if (document.location.host.includes('qlf.sezane.dev') || document.location.host.includes('qlf.octobre-editions.dev')) {
    environment = 'qlf';
}
else if (document.location.host.includes('sezane.com') || document.location.host.includes('octobre-editions.com')) {
    environment = 'prod';
}
export default environment;
